import {Component, EventEmitter, Input, OnChanges, Output, SimpleChanges} from '@angular/core';
import {Blog} from '../../shared/blog';
import {BlogService} from '../../shared/blog.service';

@Component({
  selector: 'app-blog-details',
  templateUrl: './blog-details.component.html',
  styleUrls: ['./blog-details.component.scss']
})
export class BlogDetailsComponent implements OnChanges {
  @Input() blog: Blog;
  @Output()
  blogSaved = new EventEmitter<string>();
  newBlog = false;
  buttonText = 'Update';

  constructor(private blogService: BlogService) {
  }

  ngOnChanges(changes: SimpleChanges) {
    if (!this.blog) {
      this.newBlog = true;
      this.blog = new Blog();
      this.buttonText = 'Create';
    }
  }

  deleteBlog() {
    this.blogService.delete(this.blog.id);
  }

  saveOrUpdate() {
    if (this.newBlog) {
      this.blogService.create(this.blog);
    } else {
      this.blogService.update(this.blog.id, this.blog);
    }
    this.blogSaved.emit('done');
  }

  onKeyTags(tags: string) {
    this.blog.tags = this.blog.tags.concat(tags.split(','));
  }

  removeTag(tag: string) {
    const index = this.blog.tags.indexOf(tag);
    if (index > -1) {
      this.blog.tags.splice(index, 1);
    }
  }

}
